import * as listVehiclesSelectors from '../listvehicles/selectors';

export const getVehicleIds = (state, id) => listVehiclesSelectors.getVehicleIds(state, id);
export const getVehiclesByIds = (state) => listVehiclesSelectors.getVehiclesByIds(state);


